import { create } from "zustand";
import { AicLockState, AicLockActions } from "./types";

export const useAicLockStore = create<AicLockState & AicLockActions>((set) => ({
	isAicLocked: false,
	lockedAt: null,
	setAicLockState: (isLocked: boolean, lockedAt: string | null) =>
		set({ isAicLocked: isLocked, lockedAt: isLocked ? lockedAt : null }),
}));
